import { Button, Modal, TextInput } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import React from "react";
import {
  changeMoviePosition,
  changeSeriesPosition,
  removeMovieFromSubCategory,
  removeSeriesFromSubCategory,
} from "../../utils/api";
import DataTable from "../common/DataTable";

const ContentModal = ({ modal2, setModal2, content, id, reload }) => {
  const [newPosition, setNewPosition] = React.useState("");
  const [buttonLoading, setButtonLoading] = React.useState(false);

  const removeDataFromSubCategory = async (type, id2) => {
    setButtonLoading(true);
    if (type === "movie") {
      const [status] = await removeMovieFromSubCategory({ subcategoryId: id, movieId: id2 });
      if (status) notifications.show({ message: "Movie Removed Successfully", color: "green" });
    }
    if (type === "series") {
      const [status] = await removeSeriesFromSubCategory({ subcategoryId: id, seriesId: id2 });
      if (status) notifications.show({ message: "Series Removed Successfully", color: "green" });
    }
    setModal2(false);
    setButtonLoading(false);
    reload();
  };

  const changeposition = async (type, id2) => {
    setButtonLoading(true);
    if (newPosition === "") return notifications.show({ message: "Please enter a position", color: "red" });
    if (type === "movie") {
      const [status] = await changeMoviePosition({ subcategoryId: id, movieId: id2, position: newPosition });
      if (status) notifications.show({ message: "Position changed successfully", color: "green" });
    }
    if (type === "series") {
      const [status] = await changeSeriesPosition({ subcategoryId: id, seriesId: id2, position: newPosition });
      if (status) notifications.show({ message: "Position changed successfully", color: "green" });
    }
    setModal2(false);
    setButtonLoading(false);
    reload();
  };

  return (
    <Modal opened={modal2} onClose={() => setModal2(false)} title="Content" size="lg">
      <DataTable
        dataSource={(content || []).map((item) => ({ ...item.item, type: item.kind }))}
        columns={[
          { title: "Name", dataIndex: "name", key: "name" },
          { title: "Type", dataIndex: "type", key: "type" },
          {
            title: "Action", dataIndex: "action", key: "action",
            render: (text, record) => (
              <div className="col2">
                <Button color="red" size="xs" onClick={() => {
                  modals.openConfirmModal({
                    title: "Are you sure you want to remove this content?",
                    labels: { confirm: "Remove", cancel: "Cancel" },
                    confirmProps: { color: "red" },
                    onConfirm: () => removeDataFromSubCategory(record.type, record._id),
                  });
                }}>Remove</Button>
                <div className="flex gap-2 mt-2">
                  <TextInput placeholder="Enter new position" size="xs" onChange={(e) => setNewPosition(e.target.value)} />
                  <Button size="xs" onClick={() => changeposition(record.type, record._id)} loading={buttonLoading}>Edit</Button>
                </div>
              </div>
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default ContentModal;
